module.exports = __webpack_public_path__ + "img/massad-large.5b0b361c.svg";